import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export const useCheckout = () => {
  const { user, login } = useAuth();
  const [busy, setBusy] = useState(null);

  const start = async (piano = "pro") => {
    if (!user) {
      toast("Accedi con Google per continuare");
      login("/tool/mimis-video#prezzo");
      return;
    }
    setBusy(piano);
    try {
      const { data } = await api.post("/payments/checkout", { origin_url: window.location.origin, piano });
      window.location.href = data.checkout_url;
    } catch (e) {
      toast.error(errMsg(e));
      setBusy(null);
    }
  };

  return { start, busy };
};

export const usePageTitle = (title, noindex = false) => {
  useEffect(() => {
    document.title = title;
    let meta = null;
    if (noindex) {
      meta = document.createElement("meta");
      meta.name = "robots";
      meta.content = "noindex, nofollow";
      document.head.appendChild(meta);
    }
    return () => {
      if (meta) meta.remove();
    };
  }, [title, noindex]);
};
